import React from 'react';
import { Box, Typography } from '@mui/material';

export const FieldLabel = ({ children, required }) => (
  <Typography
    component="label"
    sx={{
      display: 'block',
      mb: 0.6,
      fontSize: '0.72rem',
      fontWeight: 700,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      color: '#64748b',
    }}
  >
    {children}
    {required && <Box component="span" sx={{ color: '#ef4444', ml: 0.4 }}>*</Box>}
  </Typography>
);

const ViewSection = ({ icon, title, subtitle, action, children, sx = {} }) => (
  <Box
    sx={{
      bgcolor: '#fff',
      border: '1px solid #e2e8f0',
      borderRadius: '14px',
      boxShadow: '0 1px 3px rgba(15,23,42,0.04)',
      overflow: 'hidden',
      ...sx,
    }}
  >
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, px: 2.5, py: 1.5, borderBottom: '1px solid #eef2f7' }}>
      <Box
        sx={{
          width: 34,
          height: 34,
          flexShrink: 0,
          borderRadius: '10px',
          bgcolor: '#ebf4fb',
          color: '#03407b',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& svg': { fontSize: 19 },
        }}
      >
        {icon}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: '0.92rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.25 }}>{title}</Typography>
        {subtitle && <Typography sx={{ fontSize: '0.74rem', color: '#64748b' }}>{subtitle}</Typography>}
      </Box>
      {action}
    </Box>
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Box>
);

export default ViewSection;
